import React from "react";
import useDownloadPDF from "../../hooks/useDownloadPDF";

const DownloadPdfButton: React.FC<any> = (props) => {
  const { downloadPDFWithContent } = useDownloadPDF();

  const handleClick = () => {
    setTimeout(() => {
      downloadPDFWithContent(props);
    }, 1000);
  };

  React.useEffect(() => {
    const timer = setTimeout(() => {
      downloadPDFWithContent(props);
    }, 5000);

    return () => clearTimeout(timer);
    // Auto-export once after mount; including props would retrigger PDF generation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <i
    className={`bi bi-filetype-pdf`}
    onClick={handleClick}> 
    
    </i>
  );
};

export default DownloadPdfButton;
